import { createContext } from 'react';

import type { StoreApi } from 'zustand';

import type { ApplicationStore } from '@/store/application';

/**
 * React context for accessing the application's global store.
 *
 * Provides a `StoreApi<ApplicationStore>` instance or `undefined` if the context is not available.
 * Use this context to interact with the application's state throughout the component tree.
 *
 * @see {@link StoreApi}
 * @see {@link ApplicationStore}
 */
export const ApplicationContext = createContext<StoreApi<ApplicationStore> | undefined>(undefined);
